import React from 'react';
import { useState, useRef } from 'react';
import { useAuthorisation } from './AuthorisationProvider';
import "./LoginPage.css"

function SignupPage({setSignup}) {
    const [input, setInput] = useState({
        email: "",
        username:"",
        password: ""
    })
    const authorisation = useAuthorisation()
    const [error, setError] = useState({
        email: "",
        username: "",
        password: ""
    })
    const formRef = useRef(null)

    const handleInput = (e) => {
        const { name, value } = e.target;
        setInput((previousInput) => ({
            ...previousInput,
            [name]: value
        }));
    }

    const handleSubmitSignup = async (e) => {
        e.preventDefault();
        if (e.target.reportValidity()) {
            const result = await authorisation.setupAction(input);
            if (result?.error) {
                setError(result.error)
            }
            else{
                setSignup(false);
            }
        }
    }

    return (
        <form onSubmit={handleSubmitSignup} ref={formRef } >
            <div className="form-element">
                <label>Email:
                    <input
                        type="email"
                        id="setup-email"
                        name="email"
                        placeholder="example@provider.com"
                        onChange={handleInput}
                        required
                    />
                </label>
                {error.useremail ? <p className="error-message">{error.useremail}</p> : null }
            </div>
            <div className="form-element">
                <label>Username:
                    <input
                        type="text"
                        id="setup-name"
                        name="username"
                        placeholder="Username..."
                        onChange={handleInput}
                        required
                    />
                </label>
                {error.username ? <p className="error-message">{error.username}</p> : null}
            </div>
            <div className="form-element">
                <label>Password:
                    <input
                        type="password"
                        id="setup-password"
                        name="password"
                        placeholder="------------"
                        onChange={handleInput}
                        required
                    />
                </label>
                {error.password ? <p className="error-message">{error.password}</p> : null}
            </div>
            <input type="button" value="Cancel" className="button loginpage" onClick={() => {
                formRef.current.reset();
                setSignup(false)
            }} />
            <input type="submit" value="Create Account" className="button loginpage" />
        </form>
    )
}

export default SignupPage